import { render, staticRenderFns } from "./FrontWall.vue?vue&type=template&id=88206710&scoped=true"
import script from "./FrontWall.vue?vue&type=script&lang=ts"
export * from "./FrontWall.vue?vue&type=script&lang=ts"
import style0 from "./FrontWall.vue?vue&type=style&index=0&id=88206710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88206710",
  null
  
)

export default component.exports